import * as React from 'react';
import { DefaultButton, PrimaryButton } from '@fluentui/react';
import { TextField } from '@fluentui/react';
import { Panel } from '@fluentui/react';
import {useContext, useEffect, useState} from "react";
import {SpinButton, Stack} from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";
import NetGrossPicker from "../../Components/NetGrossPicker";

function AddProject(props) {
    const [user] = useContext(AuthContext);
    const [name, setName] = useState('');
    const [internalNumber, setInternalNumber] = useState('');
    const [net, setNet] = useState(0);
    const [vat, setVat] = useState(0);
    const [gross, setGross] = useState(0);
    const [divider, setDivider] = useState(1);
    const [whole, setWhole] = useState(1);
    const [number, setNumber] = useState('');
    const [location, setLocation] = useState('');
    const [locationNumber, setLocationNumber] = useState('');
    const [account, setAccount] = useState(0);

    const _submit = (e) => {
        e.preventDefault();
        const data = {
            name: name,
            net_value: net,
            vat: vat,
            gross_value: gross,
            venture_id: props.add.venture_id,
            account: account,
            divider: divider,
            internal_number: internalNumber,
            number: number,
            whole: whole,
            location: location,
            location_number: locationNumber
        };
        fetch(`/api/project`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddProject'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        setName('');
        setAccount('');
        setInternalNumber('');
        setNet(0);
        setGross(0);
        setDivider(1);
        setWhole(1);
        setNumber('');
        setLocation('');
        setLocationNumber('');
    }, [props.add])


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Projekt"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddProject'>
                <TextField required autoFocus label='Nazwa' value={name} onChange={(e) => setName(e.target.value || '')}/>
                <TextField label='Numer Wewnętrzny' value={internalNumber} onChange={(e) => setInternalNumber(e.target.value || '')}/>
                <TextField label='Konto' value={account} onChange={(e) => setAccount(e.target.value || '')}/>
                <NetGrossPicker net={net} setNet={setNet} gross={gross} setGross={setGross} vat={vat} setVat={setVat} />
                <SpinButton
                    label={'Rozmiar Lokalu:'}
                    labelPosition={'top'}
                    min={0.0001}
                    step={0.0001}
                    max={10000000000}
                    incrementButtonAriaLabel={'Increase value by 1'}
                    decrementButtonAriaLabel={'Decrease value by 1'}
                    value={divider}
                    onChange={(e) => setDivider(e.target.value || '')}
                />
                <SpinButton
                    label={'Rozmiar Działki:'}
                    labelPosition={'top'}
                    min={0.0001}
                    step={0.0001}
                    max={10000000000}
                    incrementButtonAriaLabel={'Increase value by 1'}
                    decrementButtonAriaLabel={'Decrease value by 1'}
                    value={whole}
                    onChange={(e) => setWhole(e.target.value || '')}
                />
                <TextField label='Numer Działki' value={locationNumber} onChange={(e) => setLocationNumber(e.target.value || '')}/>
                <TextField label='Budynek' value={number} onChange={(e) => setNumber(e.target.value || '')}/>
                <TextField label='Poziom na' value={location} onChange={(e) => setLocation(e.target.value || '')}/>
            </form>
        </Panel>
    )
}

export default AddProject;